import BillLading from '@/components/BillLading/BillLading';
export default {
    name: "collectBillDetail",
	conditionData:'',
	mounted: function () {
      this.init();
	},
	components:{
      BillLading
	},
    data() {
        return {
			edit: true,
			showBillLading : true,
			showPdf :false,
            billLadingData: {
                shipper: "shipper input text",
                consignee: "consignee input text",
                notifyParty: "notifyPart input text", ///
                placeOfreceipt: "placeOfreceipt input text",
                vessel: "vessel input text",
                portOfLoading: "portOfLoading input text",
                portOfTransshipment: "portOfTransshipment input text",
                PortOfDischarge: "portOfDischarge input text", ///
                PlaceOfDelivery: "placeOfDelivery input text", //
                freightCharges: "freightAndCharges input text", //
                NoOfOriginal: "noOfOriginal input text", //
                declared: "declared input text",
                voyageNo: "voyageNo input text",
                preCarriageBy: "carriageBy input text", //
                planceAndDate: "planceAndDate input text",
                forwardingAgent: "forAgent input text", //
                signedBy: "",
                typeOfMovement: "typeOfMovement input text",
                blNo: "billNo input text", //
				goodList:[]
            },
			billDetailForm: {
				signer:'',
				issuingParty_label:'',
				billingFee:'',
				issuingTime:'',
				portOfDischarge:'',
				payment:''
			},
			fileExpressRefVo:[]
        }
    },
    methods: {
        init(){
			this.conditionData = this.$routerUtil.getParam();
			if(this.conditionData.row){
				this.billLadingData.shipper = this.conditionData.row.shipper;
				this.billLadingData.consignee = this.conditionData.row.consignee;
				this.billLadingData.notifyParty = this.conditionData.row.notifyParty;
				this.billLadingData.placeOfreceipt = this.conditionData.row.placeOfreceipt;
				this.billLadingData.vessel = this.conditionData.row.vessel;
				this.billLadingData.portOfLoading = this.conditionData.row.portOfLoading;
				this.billLadingData.portOfTransshipment = this.conditionData.row.portOfTransshipment;
				this.billLadingData.PortOfDischarge = this.conditionData.row.PortOfDischarge;
				this.billLadingData.PlaceOfDelivery = this.conditionData.row.PlaceOfDelivery;
				this.billLadingData.freightCharges = this.conditionData.row.freightCharges;
				this.billLadingData.NoOfOriginal = this.conditionData.row.NoOfOriginal;
				this.billLadingData.declared = this.conditionData.row.declared;
				this.billLadingData.voyageNo = this.conditionData.row.voyageNo;
				this.billLadingData.preCarriageBy = this.conditionData.row.preCarriageBy;
				this.billLadingData.planceAndDate = this.conditionData.row.planceAndDate;
				this.billLadingData.forwardingAgent = this.conditionData.row.forwardingAgent;
				this.billLadingData.signedBy = this.conditionData.row.signedBy;
				this.billLadingData.typeOfMovement = this.conditionData.row.typeOfMovement;
				this.billLadingData.blNo = this.conditionData.row.blNo;
				this.billLadingData.finalDestination = this.conditionData.row.finalDestination;
				this.billLadingData.totalNumber = this.conditionData.row.totalNumber;
				this.billLadingData.goodList = this.conditionData.row.billGoods;
				this.billDetailForm.signer = this.conditionData.row.signatureCompanyId;
				this.billDetailForm.issuingParty_label = this.conditionData.row.sendCompanyId;
				this.billDetailForm.billingFee = this.conditionData.row.sendBillFeeCompanyId;
				this.billDetailForm.issuingTime = this.conditionData.row.sendBillDate;
				this.billDetailForm.portOfDischarge = this.conditionData.row.costId;
				this.billDetailForm.payment = parseInt(this.conditionData.row.payType);
				this.fileExpressRefVo = this.conditionData.row.fileExpressRefVo;
			}
		},
		doBack(){
			this.$routerUtil.setParam(this.conditionData.searchForm);
			this.$router.push('BillManage');
		},
    }
}